import * as React from "react";
import {useState} from "react";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";
import {UserInfo} from "../../model/UserInfo.model";
import {formatNumericDate} from "../../utils/dateUtil";
import {capitalizeFirstLetter} from "../../utils/commonUtil";
import {DialogComponent} from "../common/Dialog.component";

export interface IMyClientUserProps {
    user: UserInfo;
    index: number;
    plan: IPlanInfo;
    onRemoveUserFromPlan: (user: UserInfo, plan: IPlanInfo) => void;
}

export const MyClientUser: React.FunctionComponent<IMyClientUserProps> = (props) => {
    const [openDialog, setOpenDialog] = useState(false);
    return renderUser();

    function renderUser() {
        const lastLoginDate = props.user.lastLoginDate ? props.user.lastLoginDate.trim() : props.user.lastLoginDate;
        return <tr className="my-clients__user-table-row my-clients__user-info"
                   key={`my-clients__user-table-row-${props.index}`} data-testid="my-clients__user-table-row">
            <td className="my-clients__user-table-column my-clients__user-info__first-name">
                {props.user.firstName}
            </td>
            <td className="my-clients__user-table-column my-clients__user-info__last-name">
                {props.user.lastName}
            </td>
            <td className="my-clients__user-table-column my-clients__user-info__email"
                data-testid="my-clients__user-info__email">
                {props.user.email}
            </td>
            <td className="my-clients__user-table-column my-clients__user-info__user-type">
                {capitalizeFirstLetter(props.user.userType)}
            </td>
            <td className="my-clients__user-table-column my-clients__user-info__last-login-date"
                data-testid="my-clients__user-info__last-login-date">
                {(lastLoginDate && formatNumericDate(lastLoginDate)) || "Never"}
            </td>
            <td className="my-clients__user-table-column">
                <div className="my-clients__remove-link-container">
                    <button type="button"
                            className="my-clients__remove-link clickable"
                            data-testid="my-clients__remove-link"
                            onClick={() => setOpenDialog(true)}>
                        Remove
                    </button>
                </div>
                {renderDeleteDialog()}
            </td>
        </tr>;
    }

    function renderDeleteDialog() {
        return <DialogComponent noText="no, keep 'em"
                                yesText="yes, remove 'em"
                                title="Remove this user from the plan?"
                                description="User will no longer have access to this plan."
                                open={openDialog}
                                onYes={() => {
                                    setOpenDialog(false);
                                    props.onRemoveUserFromPlan(props.user, props.plan);
                                }}
                                onNo={() => setOpenDialog(false)}
        />;
    }
};

export default MyClientUser;
